var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.25C6.0225 2.25 3 5.2725 3 9H0.75L3.75 11.9925L6.75 9H4.5C4.5 6.0975 6.8475 3.75 9.75 3.75C12.6525 3.75 15 6.0975 15 9C15 11.9025 12.6525 14.25 9.75 14.25C8.3025 14.25 6.99 13.6575 6.045 12.705L4.98 13.77C6.2025 14.9925 7.8825 15.75 9.75 15.75C13.4775 15.75 16.5 12.7275 16.5 9C16.5 5.2725 13.4775 2.25 9.75 2.25ZM9 6V9.75L12.1875 11.64L12.765 10.68L10.125 9.1125V6H9Z",
    fill: "#044154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/Restore.2834e972ab302846be3203ac4c198b2e.svg";
export { ForwardRef as ReactComponent };